import { default as app_45errorvgOLcxL3KlMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue?macro=true";
import { default as _91id_93hgayPSiVX5Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue?macro=true";
import { default as _91id_931hoZGm8fGPMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsPrograms/[id].vue?macro=true";
import { default as _91id_93apirzXHCUjMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodMovies/[id].vue?macro=true";
import { default as _91id_93JI43yJVCLXMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodSeries/[id].vue?macro=true";
import { default as indexUHQMhe33cYMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue?macro=true";
import { default as indexh2vPEkWnbIMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue?macro=true";
import { default as indexGyXimxtLyPMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/index.vue?macro=true";
import { default as show_45allpgnpN9H1lnMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/show-all.vue?macro=true";
import { default as indexYHErFM6EWjMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue?macro=true";
import { default as forgotEkE9TotvsNMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/forgot.vue?macro=true";
import { default as indexVrM304dhxXMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/index.vue?macro=true";
import { default as sign_45inUFdrAIoqK5Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/sign-in.vue?macro=true";
import { default as all_45on_45demand9QFzATUWZwMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-on-demand.vue?macro=true";
import { default as all_45programsGqMYtjsUSaMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-programs.vue?macro=true";
import { default as indexm74nxKWFwDMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/index.vue?macro=true";
import { default as show_45all_45fav_45channelsfMGCGZh0uuMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/show-all-fav-channels.vue?macro=true";
import { default as indexWXVrmEAsLhMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue?macro=true";
import { default as playerLvBhWQ4WnhMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue?macro=true";
import { default as index3i8RqgHK0MMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/index.vue?macro=true";
import { default as show_45allT4wUiGRBd3Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/show-all.vue?macro=true";
import { default as about_45usja7JhwUtKQMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/about-us.vue?macro=true";
import { default as indexBnP6jj71BEMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/account/index.vue?macro=true";
import { default as clear_45cacheFGSbyjUsSQMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/clear-cache.vue?macro=true";
import { default as dev_45modeG0sDxL42NQMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/dev-mode.vue?macro=true";
import { default as favorites8lMIIkanRSMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/favorites.vue?macro=true";
import { default as indexlt1lSyYlGIMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/language/index.vue?macro=true";
import { default as index9e9gMlh3AlMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/parent-control/index.vue?macro=true";
import { default as indexxOwknH2h4hMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/player/index.vue?macro=true";
import { default as privacy_45policyzothaUE3UIMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/privacy-policy.vue?macro=true";
import { default as subscriptionH1ojxxoB46Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/subscription.vue?macro=true";
import { default as settingsYMjlYoiLvuMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings.vue?macro=true";
import { default as loader6Pd9W9zzHQMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue?macro=true";
import { default as logovldBb3uK2WMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue?macro=true";
import { default as maxi1XUTeJpii6Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue?macro=true";
import { default as index3pOnzfaFC5Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/trailer/index.vue?macro=true";
import { default as _91id_938EfsCNpJB6Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/detail-genre/[id].vue?macro=true";
import { default as _91id_93FUVffRdl06Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres-premium/[id].vue?macro=true";
import { default as _91id_93ogrYp4rodfMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres/[id].vue?macro=true";
import { default as indexxGqPngSSWSMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/index.vue?macro=true";
import { default as show_45all_45channelsY6BKAsTWguMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-channels.vue?macro=true";
import { default as show_45all_45moviesbNUA8OQAY6Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-movies.vue?macro=true";
import { default as show_45all_45subitems7VkgSqPXMFMeta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-subitems.vue?macro=true";
import { default as show_45allhmVT7pIlR3Meta } from "D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all.vue?macro=true";
export default [
  {
    name: "app-error",
    path: "/app-error",
    meta: app_45errorvgOLcxL3KlMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue").then(m => m.default || m)
  },
  {
    name: "detailsCast-id",
    path: "/detailsCast/:id()",
    meta: _91id_93hgayPSiVX5Meta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsPrograms-id",
    path: "/detailsPrograms/:id()",
    meta: _91id_931hoZGm8fGPMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsPrograms/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsVodMovies-id",
    path: "/detailsVodMovies/:id()",
    meta: _91id_93apirzXHCUjMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodMovies/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsVodSeries-id",
    path: "/detailsVodSeries/:id()",
    meta: _91id_93JI43yJVCLXMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodSeries/[id].vue").then(m => m.default || m)
  },
  {
    name: "guide",
    path: "/guide",
    meta: indexUHQMhe33cYMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue").then(m => m.default || m)
  },
  {
    name: "help",
    path: "/help",
    meta: indexh2vPEkWnbIMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    meta: indexGyXimxtLyPMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/index.vue").then(m => m.default || m)
  },
  {
    name: "home-show-all",
    path: "/home/show-all",
    meta: show_45allpgnpN9H1lnMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/show-all.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexYHErFM6EWjMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login-forgot",
    path: "/login/forgot",
    meta: forgotEkE9TotvsNMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/forgot.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: indexVrM304dhxXMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "login-sign-in",
    path: "/login/sign-in",
    meta: sign_45inUFdrAIoqK5Meta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/sign-in.vue").then(m => m.default || m)
  },
  {
    name: "mytv-all-on-demand",
    path: "/mytv/all-on-demand",
    meta: all_45on_45demand9QFzATUWZwMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-on-demand.vue").then(m => m.default || m)
  },
  {
    name: "mytv-all-programs",
    path: "/mytv/all-programs",
    meta: all_45programsGqMYtjsUSaMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-programs.vue").then(m => m.default || m)
  },
  {
    name: "mytv",
    path: "/mytv",
    meta: indexm74nxKWFwDMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/index.vue").then(m => m.default || m)
  },
  {
    name: "mytv-show-all-fav-channels",
    path: "/mytv/show-all-fav-channels",
    meta: show_45all_45fav_45channelsfMGCGZh0uuMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/show-all-fav-channels.vue").then(m => m.default || m)
  },
  {
    name: playerLvBhWQ4WnhMeta?.name,
    path: "/player",
    meta: playerLvBhWQ4WnhMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue").then(m => m.default || m),
    children: [
  {
    name: "player",
    path: "",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "search",
    path: "/search",
    meta: index3i8RqgHK0MMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: "search-show-all",
    path: "/search/show-all",
    meta: show_45allT4wUiGRBd3Meta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/show-all.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "settings-about-us",
    path: "about-us",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/about-us.vue").then(m => m.default || m)
  },
  {
    name: "settings-account",
    path: "account",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/account/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-clear-cache",
    path: "clear-cache",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: "settings-dev-mode",
    path: "dev-mode",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/dev-mode.vue").then(m => m.default || m)
  },
  {
    name: "settings-favorites",
    path: "favorites",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/favorites.vue").then(m => m.default || m)
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/language/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-parent-control",
    path: "parent-control",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/parent-control/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-player",
    path: "player",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/player/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-privacy-policy",
    path: "privacy-policy",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "settings-subscription",
    path: "subscription",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/subscription.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "splash-loader",
    path: "/splash/loader",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue").then(m => m.default || m)
  },
  {
    name: "splash-logo",
    path: "/splash/logo",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue").then(m => m.default || m)
  },
  {
    name: "splash-maxi",
    path: "/splash/maxi",
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue").then(m => m.default || m)
  },
  {
    name: "trailer",
    path: "/trailer",
    meta: index3pOnzfaFC5Meta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/trailer/index.vue").then(m => m.default || m)
  },
  {
    name: "vod-detail-genre-id",
    path: "/vod/detail-genre/:id()",
    meta: _91id_938EfsCNpJB6Meta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/detail-genre/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod-genres-premium-id",
    path: "/vod/genres-premium/:id()",
    meta: _91id_93FUVffRdl06Meta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres-premium/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod-genres-id",
    path: "/vod/genres/:id()",
    meta: _91id_93ogrYp4rodfMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod",
    path: "/vod",
    meta: indexxGqPngSSWSMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/index.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-channels",
    path: "/vod/show-all-channels",
    meta: show_45all_45channelsY6BKAsTWguMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-channels.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-movies",
    path: "/vod/show-all-movies",
    meta: show_45all_45moviesbNUA8OQAY6Meta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-movies.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-subitems",
    path: "/vod/show-all-subitems",
    meta: show_45all_45subitems7VkgSqPXMFMeta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-subitems.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all",
    path: "/vod/show-all",
    meta: show_45allhmVT7pIlR3Meta || {},
    component: () => import("D:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all.vue").then(m => m.default || m)
  }
]